import { createContext, useContext } from 'react'

// Création du contexte
const BienContext = createContext()

// Hook personnalisé pour utiliser le contexte
export const useBienContext = () => useContext(BienContext)

export default BienContext